module.exports = __webpack_public_path__ + "static/img/3.28bc4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R417A/3.jpg
// module id = X5Nd
// module chunks = 1